var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStreaming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "podcast") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#de6139",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10.5,
    r: 2.5,
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0A11.99,11.99,0,0,0,6.857,22.826l-.27-2.43a10,10,0,1,1,10.826,0l-.27,2.43A11.99,11.99,0,0,0,12,0Z",
    fill: "#de6139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.136,16.331a3,3,0,0,1,.41-1.866A5.927,5.927,0,0,1,6,12a6,6,0,0,1,12,0,5.927,5.927,0,0,1-.546,2.465,3,3,0,0,1,.41,1.866l-.137,1.24a8,8,0,1,0-11.454,0Z",
    fill: "#de6139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.117,15h5.766a1,1,0,0,1,.994,1.11L15,24H9l-.877-7.89A1,1,0,0,1,9.117,15Z",
    "data-color": "color-2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreaming);
export default __webpack_public_path__ + "static/media/streaming.c5d0ceb7.svg";
export { ForwardRef as ReactComponent };